// Lazy-Loader für @fancyapps/ui (~139 KiB min / ~35 KiB gzip). Der Impl-Chunk
// (fanybox-impl.js) wird erst in Idle-Zeit nach dem Mount gebunden — oder sofort
// beim ersten Klick auf ein [data-fancybox]. Bindet Fancybox mit denselben
// Optionen wie zuvor; keine UX-Änderung ausser der einmaligen Chunk-Ladezeit.

function init({ onReveal } = {}) {
    let ready = null;
    const load = () => {
        if (!ready) ready = import("./fanybox-impl.js").then((m) => { m.init({ onReveal }); return m; });
        return ready;
    };

    // Erster Klick auf ein [data-fancybox] vor dem Idle-Load: Default
    // unterdrücken, Chunk laden, danach Fancybox öffnen — sonst würde der
    // Klick ins Leere laufen. Der Handler bleibt auf document (Capture) bis
    // Fancybox gebunden ist und deckt so auch Trigger ab, die erst NACH dem
    // Boot ins DOM kommen (z. B. in Vue-Komponenten wie <card-slider>, die
    // ihren Slot-Inhalt beim Mount verschieben). Kein früher return auf
    // "kein Trigger beim Boot" mehr — der hat genau diese Fälle verschluckt.
    const onFirstClick = (e) => {
        const trigger = e.target.closest("[data-fancybox]");
        if (!trigger) return;
        e.preventDefault();
        e.stopPropagation();
        document.removeEventListener("click", onFirstClick, true);
        load().then(() => trigger.click());
    };
    document.addEventListener("click", onFirstClick, true);

    // Fancybox in Idle-Zeit binden — aber nur, wenn dann ein Trigger existiert.
    // Ist noch keiner da (Vue noch am Mounten), erneut im nächsten Idle-Fenster
    // versuchen, bis einer erscheint. So bleibt der Lazy-Vorteil erhalten und
    // Fancybox delegiert danach selbst dynamisch auf alle [data-fancybox].
    const idleBind = () => {
        if (ready) return;
        if (document.querySelector("[data-fancybox]")) {
            load().then(() => document.removeEventListener("click", onFirstClick, true));
        } else {
            scheduleIdle();
        }
    };
    const scheduleIdle = () => {
        if ("requestIdleCallback" in window) requestIdleCallback(idleBind, { timeout: 3000 });
        else setTimeout(idleBind, 1500);
    };
    scheduleIdle();
}

export { init }
